// Product management functions
import { collection, addDoc, getDocs, doc, updateDoc, deleteDoc, getDoc, query, where, orderBy, serverTimestamp } from 'firebase/firestore';
import { db } from './config';

/**
 * Get all products
 */
export const getAllProducts = async (filters = {}) => {
  try {
    const productsRef = collection(db, 'products');
    let q = query(productsRef, orderBy('order', 'asc'));
    
    if (filters.status) {
      q = query(q, where('status', '==', filters.status));
    }
    
    if (filters.type) {
      q = query(q, where('type', '==', filters.type));
    }
    
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  } catch (error) {
    console.error('Error getting products:', error);
    return [];
  }
};

/**
 * Get a single product by ID
 */
export const getProduct = async (productId) => {
  try {
    const productRef = doc(db, 'products', productId);
    const snapshot = await getDoc(productRef);
    
    if (snapshot.exists()) {
      return { id: snapshot.id, ...snapshot.data() };
    }
    return null;
  } catch (error) {
    console.error('Error getting product:', error);
    return null;
  }
};

/**
 * Create a new product
 */
export const createProduct = async (productData) => {
  try {
    const productsRef = collection(db, 'products');
    
    // Get current max order
    const allProducts = await getAllProducts();
    const maxOrder = allProducts.length > 0 
      ? Math.max(...allProducts.map(p => p.order || 0))
      : 0;
    
    const newProduct = {
      ...productData,
      order: productData.order !== undefined ? productData.order : maxOrder + 1,
      status: productData.status || 'draft',
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    };
    
    const docRef = await addDoc(productsRef, newProduct);
    return { success: true, id: docRef.id };
  } catch (error) {
    console.error('Error creating product:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Update a product
 */
export const updateProduct = async (productId, updates) => {
  try {
    const productRef = doc(db, 'products', productId);
    await updateDoc(productRef, {
      ...updates,
      updatedAt: serverTimestamp()
    });
    return { success: true };
  } catch (error) {
    console.error('Error updating product:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Delete a product
 */
export const deleteProduct = async (productId) => {
  try {
    const productRef = doc(db, 'products', productId);
    await deleteDoc(productRef);
    return { success: true };
  } catch (error) {
    console.error('Error deleting product:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Reorder products (for drag-and-drop)
 */
export const reorderProducts = async (productOrders) => {
  try {
    const updatePromises = productOrders.map(({ id, order }) => {
      const productRef = doc(db, 'products', id);
      return updateDoc(productRef, { order, updatedAt: serverTimestamp() });
    });
    
    await Promise.all(updatePromises);
    return { success: true };
  } catch (error) {
    console.error('Error reordering products:', error);
    return { success: false, error: error.message };
  }
};















